// src/web/Landing.jsx

import { useAuth } from '../auth/authContext';

import HeroBanner from '../components/banners/HeroBanner';
import ServicesBanner from '../components/banners/ServicesBanner';
import VisionMissionValuesBanner from '../components/banners/VisionMissionValuesBanner';
import CommunityStatsBanner from '../components/banners/CommunityStatsBanner';
import SelectedParticipantExperiences from '../features/community-experience/SelectedParticipantExperiences';
import AppAccessBanner from '../components/banners/AppAccessBanner';
//import ShopBanner from '../components/banners/ShopBanner';
import ConnectBanner from '../components/banners/ConnectBanner';
//import WVDBanner from '../components/banners/WVDBanner';

import PageTracker from '../components/tracking/PageTracker';
import ScrollTracker from '../components/tracking/ScrollTracker';

function Landing() {
  const { user } = useAuth();

  return (
    <div className="landing-wrapper">
      <PageTracker pageName="LandingPage" />
      <HeroBanner />
      {/*<WVDBanner />*/}
      <ServicesBanner />
      <VisionMissionValuesBanner />
      {/*<ShopBanner />*/}
      {!user && <AppAccessBanner />}
      <CommunityStatsBanner />
      <SelectedParticipantExperiences />
      <ConnectBanner />

      <ScrollTracker pageName="LandingPage" />
    </div>
  );
}

export default Landing;
